import { FieldMapShape } from './shape/field-map-shape';
import { Field } from './shape/field';
import { Injectable } from '@angular/core';
import { Block } from './shape/block';
import { Study } from './shape/study';

export interface FieldMapShapeEventHandler {
    (shape: FieldMapShape): void
};

export interface FieldMapTransformEventHandler {
    (data: {isOutOfBoundary: boolean}, shape: FieldMapShape): void
};

@Injectable({ providedIn: 'root' })
export class FieldMapContext {

    drawingMode: 'FIELD' | 'BLOCK' | 'STUDY' | null = null;
    editOptionsSelectedValue: 'EDIT' | 'RESIZE' | 'ROTATE' | null;
    mouseEventListenerEnabled = true;
    fieldsMap: Map<string, Field> = new Map<string, Field>();
    blocksMap: Map<string, Block> = new Map<string, Block>();
    studiesMap: Map<string, Study> = new Map<string, Study>();
    cropName: string;
    programUUID: string;

    onShapeTransforming: FieldMapTransformEventHandler;
    onShapeClicked: FieldMapShapeEventHandler;
    onShapeSelected: FieldMapShapeEventHandler;
    onShapeUnSelected: FieldMapShapeEventHandler;
    onBeforeShapeCommit: (shape: FieldMapShape) => Promise<any> = undefined;
    onAfterShapeCommit: FieldMapShapeEventHandler;
    onShapeMouseOver: FieldMapShapeEventHandler;
    onShapeMouseOut: FieldMapShapeEventHandler;
    onBeforeDelete: (shape: FieldMapShape) => Promise<any> = undefined;

    disableMouseEventListeners() {
        this.mouseEventListenerEnabled = false;
    }

    enableMouseEventListeners() {
        this.mouseEventListenerEnabled = true;
    }

    shapeClicked(shape: FieldMapShape) {
        if (this.onShapeClicked) {
            this.onShapeClicked(shape);
        }
    }

    shapeSelected(shape: FieldMapShape) {
        if (this.onShapeSelected) {
            this.onShapeSelected(shape);
        }
    }

    shapeUnSelected(shape: FieldMapShape) {
        if (this.onShapeUnSelected) {
            this.onShapeUnSelected(shape);
        }
    }

    beforeShapeCommit(shape: FieldMapShape): Promise<void> {
        if (this.onBeforeShapeCommit) {
            return this.onBeforeShapeCommit(shape);
        }
    }

    afterShapeCommit(shape: FieldMapShape) {
        if (this.onAfterShapeCommit) {
            this.onAfterShapeCommit(shape);
        }
    }

    beforeDelete(shape: FieldMapShape) {
        if (this.onBeforeDelete) {
            return this.onBeforeDelete(shape);
        }
    }

    shapeTransforming(data: { isOutOfBoundary: boolean }, shape: FieldMapShape, ) {
        if (this.onShapeTransforming) {
            this.onShapeTransforming(data, shape);
        }
    }

    shapeMousOver(shape: FieldMapShape) {
        if (this.onShapeMouseOver) {
            return this.onShapeMouseOver(shape);
        }
    }

    shapeMouseOut(shape: FieldMapShape) {
        if (this.onShapeMouseOut) {
            return this.onShapeMouseOut(shape);
        }
    }
}
